<script setup lang="ts">
import AssetFieldsItem from "@/components/common/molecules/AssetFieldsItem.vue";

interface Props {
  customerId: string;
  labelClasses: string;
  ignore?: boolean;
  showControls?: boolean;
  disabled?: boolean;
  name?: string;
}

withDefaults(defineProps<Props>(), {
  ignore: false,
  showControls: true,
  disabled: false,
  name: "asset_fields_repeater",
});
</script>

<template>
  <FormKit
    :ignore
    type="repeater"
    :name
    :up-control="false"
    :down-control="false"
    :disabled
    :classes="{
      item: 'group !border-none',
      content: '!flex-row gap-3 w-full !pl-0',
      controls: '!py-1 !bg-transparent' + (!showControls ? ' hidden' : ''),
      insert: 'group-[:not(:first-of-type)]:hidden',
      remove: 'group-first:hidden',
      outer: 'grow',
    }"
    :add-button="false"
    add-icon="faPlusSquare"
    remove-icon="faMinusSquare"
    :insert-control="true"
    :remove-control="true"
  >
    <AssetFieldsItem :customer-id="customerId" :label-classes="labelClasses" />
    <template #addIcon>
      <i class="fa-solid fa-plus-square text-primary text-xl" />
    </template>
    <template #removeIcon>
      <i class="fa-solid fa-minus-square text-primary text-xl" />
    </template>
  </FormKit>
</template>
